<script setup lang="ts">
import NuxtLink from '~/tests/_mocks/NuxtLink.vue'

const localePath = useLocalePath()
const route = useRoute()

const yearStart = 2016
const yearEnd = new Date().getFullYear()

const years = Array.from({ length: yearEnd - yearStart + 1 }, (_, i) => yearEnd - i)

function getYearPath(year: number) {
  return localePath({ name: 'newsEvents-pressReleases-year', params: { year } })
}

function isActiveYear(year: number) {
  return parseInt(route.params.year as string, 10) === year
}
</script>

<template>
  <div class="FacetedExplorer">
    <div class="GpcMenuWrapper">
      <ul class="GpcMenu FacetedNavigation">
        <li class="GpcMenuCategory">
          <NuxtLink class="GpcMenuCategoryTitle"
                    :to="localePath('newsEvents-pressReleases')">
            {{ $t('navigation.pressReleases.name') }}
          </NuxtLink>
          <ul>
            <li v-for="year in years"
                :key="year"
                class="GpcMenuItem CFVID38">
              <NuxtLink class="GpcItemTitle"
                        :class="{ 'router-link-active': isActiveYear(year) }"
                        :to="getYearPath(year)">
                {{ year }}
              </NuxtLink>
            </li>
          </ul>
        </li>
      </ul>
      <div class="lienPresentation">
        <NuxtLink class="GpcMenuCategoryTitle"
                  :to="localePath('investorRelations-financialDocuments-presentationsWebcasts')">
          {{ $t('navigation.presentationsWebcasts.name') }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
